import { useStickyAtbSlideoutContextEnabled } from './context-providers/useStickyAtbSlideoutContextEnabled';
import { useStickyAtbContextEnabled } from './context-providers/useStickyAtbContextEnabled';
import useIsolatedStickyAtbStateStore from '../stores/useIsolatedStickyAtbStateStore';
import { fireLinkTag } from '~/features/analytics/tagManager';
import once from '~/utils/once';

export default function useStickyAtbAnalytics() {
  const isStickyAtbEnabled = !!useIsolatedStickyAtbStateStore()?.isStickyAtbEnabled;

  const fireLinkTageWithSetTimeout = <T>(payload: T) => setTimeout(() => fireLinkTag(payload));

  const isAppContextStickyEnabled = (() => {
    if (!isStickyAtbEnabled) return false;
    return useStickyAtbSlideoutContextEnabled().isStickyAtbSlideoutContextEnabled || useStickyAtbContextEnabled().isStickyAtbContextEnabled;
  })();

  const extraTraitsData = (type: 'color' | 'size' | 'type') => {
    if (!isAppContextStickyEnabled) return {};
    let linkName = '';

    switch (type) {
      case 'color':
        linkName = 'sticky atb:color swatch';
        break;
      case 'size':
        linkName = 'sticky atb:size swatch';
        break;
      case 'type':
        linkName = 'sticky atb:type swatch';
        break;
      default:
        break;
    }

    return {
      event_name: 'sticky atb:product select sku',
      link_name: linkName,
    };
  };

  const extraBagData = () => ({
    ...(isAppContextStickyEnabled && { bag_add_location: 'pdp sticky atb' }),
  });

  const fireMakeSelectionLinkTagOnce = once(() => {
    if (isAppContextStickyEnabled) {
      fireLinkTageWithSetTimeout({
        event_name: 'sticky atb:make selection',
        link_name: 'sticky atb:make selection',
      });
    }
  });

  const fireEditSelectionLinkTagOnce = once(() => {
    if (isAppContextStickyEnabled) {
      fireLinkTageWithSetTimeout({
        event_name: 'sticky atb:edit selection',
        link_name: 'sticky atb:edit selection',
      });
    }
  });

  return {
    extraTraitsData,
    extraBagData,
    fireMakeSelectionLinkTagOnce,
    fireEditSelectionLinkTagOnce,
  };
}
